"use client";

import { useEffect, useState } from "react";

// Returns "ios" (iPhone/iPad), "android" (Android), or "both" (desktop, Windows, Mac, Linux)
export function useStorePlatform() {
  const [platform, setPlatform] = useState("both");

  useEffect(() => {
    const detect = () => {
      if (typeof window === "undefined" || typeof navigator === "undefined") return;

      const ua = navigator.userAgent || "";
      const uaPlatform = navigator.userAgentData?.platform?.toLowerCase() || "";

      const isIOS =
        /iPhone|iPad|iPod/i.test(ua) ||
        uaPlatform.includes("ios") ||
        uaPlatform.includes("iphone") ||
        uaPlatform.includes("ipad") ||
        // iPadOS masquerades as Macintosh with touch support
        (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);

      const isAndroid =
        /Android/i.test(ua) ||
        uaPlatform.includes("android");

      if (isIOS) {
        setPlatform("ios");
      } else if (isAndroid) {
        setPlatform("android");
      } else {
        // Desktop browsers (Windows, macOS without touch, Linux) see both options
        setPlatform("both");
      }
    };

    detect();
  }, []);

  return platform;
}
